import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import classes from './index.module.css';

const propTypes = {
  className: PropTypes.string,
  noSpacing: PropTypes.bool,
  noTop: PropTypes.bool,
  noBottom: PropTypes.bool,
  isInComponent: PropTypes.bool,
};

const defaultProps = {
  className: '',
  noSpacing: false,
  noTop: false,
  noBottom: false,
  isInComponent: false,
};

export default function Separator({ className, noSpacing, noTop, noBottom, isInComponent }) {
  return (
    <div
      data-testid="separator"
      className={classnames('w-100', classes['section-separator'], {
        'z-mt-68 z-mt-lg-88': !noSpacing && !noTop,
        'z-mb-68 z-mb-lg-88': !noSpacing && !noBottom,
        [classes['component-separator']]: isInComponent,
      }, className)}
    />
  );
}

Separator.propTypes = propTypes;
Separator.defaultProps = defaultProps;
